import React from 'react'
import Orders from '../Component/Orders'

const Orderrs = () => {
  return (
    <div>
      <Orders/>
    </div>
  )
}

export default Orderrs
